import React from 'react';

export default class OrgnaizationManagement extends React.Component
{
    constructor(props)
    {
        super(props);
        this.state = {
            loaded: false,
            error: "",
            organizations: []
        }
    }
    componentDidMount()
    {
        this.getOrganizations();
    }
    getOrganizations()
    {
        this.props.api.send({
            controller: "Organization",
            action: "GetOrganizations",
            method: "get",
            success: (result) => {
                result.success ?
                    this.setState({loaded: true, organizations: result.orgs}) :
                    this.setState({loaded: true, error: result.message})

                console.dir(result);
            },
            error: (err) => {
                this.setState({loaded: true, error: "Unable to load organizations.  Please try again later."})
            }
        })
    }
    editClick(e, oid)
    {

    }
    deleteClick(e, oid)
    {

    }
    render()
    {
        const organizationrows = this.state.organizations.map((o) =>
        <tr key={o.organizationID}>
            <td>{o.organizationName}</td>
            <td>
                {o.address1}
                {o.address2.trim() !== "" ? (<span><br />{o.address2}</span>) : null}
                <br />{o.city}, {o.state} {o.zip}
            
            </td>
            <td style={{width: "155px"}}>
                <a className="lmsbutton" href="/" onClick={(e) => this.editClick(e, o.organizationID)}>Edit</a>
                <a className="lmsbutton" href="/" onClick={(e) => this.deleteClick(e, o.organizationID)}>Delete</a>
            </td>
        </tr>
    )
        return (
            <div className="lmsdisplayarea">
                <h3>Manage Organizations</h3>
                <p>
                    <a className="lmsbutton" href="/" onClick={(e) => this.createClick(e)}>Create Organization</a>
                </p>
                {this.state.loaded ?
                    this.state.organizations.length === 0 ? (
                      <div>No organizations are registered.</div>
                    ) : (
                        <div className="lmstablecontainer">
                            <table className="lmstable">
                                <thead>
                                    <tr>
                                        <th>Organization Name</th>
                                        <th>Organization Address</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {organizationrows}
                                </tbody>
                            </table>
                        </div>
                    )  
                : (
                    <div className="lmscenter"><img src="/images/spinner.svg" alt="Loading..." /></div>
                )}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/organization/organizationmanagement.js